/** Parse a number input into a value or null when blank/invalid. */
export const toNullableNumber = (target: HTMLInputElement | HTMLTextAreaElement): number | null => {
  const value = (target as HTMLInputElement).valueAsNumber;
  return Number.isFinite(value) ? value : null;
};

/**
 * Parse a number input, raising anything below `min` up to it. The `min`
 * attribute only binds the stepper arrows and native form validation, so a
 * typed-in value below it reaches the handler unchanged.
 *
 * Blank stays null so the field can still be cleared and retyped — clamping it
 * would refill the input on every backspace.
 */
export const toClampedNumber = (
  target: HTMLInputElement | HTMLTextAreaElement,
  min: number
): number | null => {
  const value = toNullableNumber(target);
  return value === null ? null : Math.max(min, value);
};